import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

import { transformResponseUserGroups } from './transformers'

const useUserGroups = ({ storeId, merchantId, doInitialRequest = false }) => {
  const service = merchantId ? configurationServices.getMerchantUserGroups : configurationServices.getUserGroups
  const params = merchantId ? { merchantId } : { storeId }
  const {
    data: userGroups,
    loading: fetchingUserGroups,
    fetchData,
  } = useFetch(service, { doInitialRequest, params, transformResponse: transformResponseUserGroups })

  const fetchUserGroups = () => fetchData(params)

  return { userGroups, fetchingUserGroups, fetchUserGroups }
}

export default useUserGroups
